import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Chartist from 'chartist'
import chartistTooltips from 'chartist-plugin-tooltips'
import DashboardPanel from '../../core/components/DashboardPanel'
import Chart, {aggregateDataTimeStep} from '../../core/components/Chart'
import i18n from '../i18n'

class InterventionNumberDashboardPanel extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, contactStats, ...others} = this.props

        const panelHeader = (
            <h4>{i18n.interventionNumber}</h4>
        )

        const aggregateDataStep = aggregateDataTimeStep({
            stepReduce: (a) => a.reduce((r, v) => r + v, 0)
        })

        const chartPlugins = [
            Chartist.plugins.tooltip({
                appendToBody: true
            })
        ]

        return (
            <DashboardPanel
                header={panelHeader}
                help={i18n.interventionNumberText}
                {...others}>
                {contactStats.interventionNumber.length > 0 && (
                    <Chart fill
                        kind='Bar'
                        plugins={chartPlugins}
                        display={(a) => new Date(a.day)}
                        identify={(a) => a.count}
                        data={aggregateDataStep}
                        value={[contactStats.interventionNumber]} />
                )}
            </DashboardPanel>
        )
    }
}

InterventionNumberDashboardPanel = connect((state) => ({
    contactStats: state.provider.contact.contactStats
}))(InterventionNumberDashboardPanel)

export default InterventionNumberDashboardPanel


// WEBPACK FOOTER //
// ./lib/provider/components/InterventionNumberDashboardPanel.js